import { useQuery } from "@tanstack/react-query";
import { fetchSongOrderSummary } from "@/utils/songOrder";
import type { SongOrderSummary } from "@/types/SongOrder";

/** Loads the order summary for a song order from the doc-profile abridged call. */
export default function useSongOrderSummary(
  docId: string | null,
  userId: string | null,
) {
  return useQuery<SongOrderSummary>({
    queryKey: ["songOrderSummary", docId, userId],
    queryFn: () => fetchSongOrderSummary(docId!, userId),
    enabled: !!docId,
    retry: 1,
  });
}
